import ErrorOrLoading from '../../shared/ErrorOrLoading'
import MonthlyCompareRainfall from '../graphs/MonthlyCompareRainfall'
import CurrentStreamFlow from '../graphs/CurrentStreamFlow'
import HistoricalStreamFlow from '../graphs/HistoricalStreamFlow'
import MonthlyComparison from '../graphs/MonthlyComparison'
import BrushZoom from '../graphs/BrushZoom'
import { ControllerType } from '../interfaces'
import { memo } from 'react'
import { useFetch } from '../../hooks'

const Controller = memo(({ url, width, type }: ControllerType) => {
  // fetch from provided url - this is get request only from RESTfull API
  const { data, error, loading } = useFetch(url)
  switch (type) {
    case 'historical rainfall':
      return (
        <div>
          <ErrorOrLoading error={error || void 0} loading={loading} />
          {
            data && (
              <BrushZoom
                data={data?.monthlyData || void 0}
                width={width}
                filename="rainfall.csv"
                linkname="Download historical rainfall data CSV"
                unit="mm"
              />
            )
          }

        </div>
      )
    case 'historical dams':
      return (
        <div>
          <ErrorOrLoading error={error || void 0} loading={loading} />
          {
            data && (
              <BrushZoom
                data={data || void 0}
                width={width}
                filename="historical-dams.csv"
                linkname="Download historical dams data CSV"
                unit="GL"
              />
            )
          }

        </div>
      )
    case 'streamflow':
      return (
        <div>
          <ErrorOrLoading error={error || void 0} loading={loading} />
          {
            data && <CurrentStreamFlow data={data || void 0} width={width} />
          }
        </div>
      )
    case 'historical streamflow':
      return (
        <div>
          <ErrorOrLoading error={error || void 0} loading={loading} />
          {
            data && <HistoricalStreamFlow data={data || void 0} width={width} />
          }

        </div>
      )
    case 'rainfall':
      return (
        <div>
          <ErrorOrLoading error={error || void 0} loading={loading} />
          {
            data && <MonthlyCompareRainfall data={data || void 0} width={width} />
          }

        </div>
      )
    default:
      return (
        <div>
          {
            data && <MonthlyComparison data={data} width={width} />
          }
          <ErrorOrLoading error={error || void 0} loading={loading} />

        </div>
      )
  }
})

export default Controller


